import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";

/**
 * Location card on dark. Naples (featured) gets a thicker cyan accent + cyan
 * top bar. Secondary cards have a subtle cyan map-pin icon.
 */
export default function LocationCard({ location, featured = false }) {
    if (featured) return <FeaturedNaplesCard location={location} />;
    return (
        <Link
            to={`/service-areas/${location.slug}`}
            className="a1-card a1-card-link no-underline flex flex-col gap-3 h-full"
            data-testid={`location-card-${location.slug}`}
        >
            <div className="flex items-center gap-2.5">
                <MapPin size={18} className="text-[var(--color-accent)] shrink-0" />
                <h3 className="text-lg" style={{ color: "var(--color-text)" }}>
                    {location.name}
                </h3>
            </div>
            <p
                className="flex-1 text-[14.5px] leading-relaxed"
                style={{ color: "var(--color-text-muted)" }}
            >
                {location.hero}
            </p>
            <span className="a1-btn-ghost">
                {location.name} service <ArrowRight size={14} />
            </span>
        </Link>
    );
}

function FeaturedNaplesCard({ location }) {
    const neighborhoods = location.neighborhoods || [];
    return (
        <Link
            to={`/service-areas/${location.slug}`}
            className="rounded-lg no-underline relative overflow-hidden block group border"
            style={{
                background: "var(--color-bg-card)",
                borderColor: "var(--color-accent)",
            }}
            data-testid={`location-card-${location.slug}`}
        >
            {/* Cyan accent top bar */}
            <div className="h-1.5" style={{ background: "var(--color-accent)" }} />
            <div className="p-6 md:p-10">
                <p className="a1-eyebrow mb-3">Home Base · Flagship Service Area</p>
                <h3
                    className="text-2xl md:text-3xl mb-3 leading-tight"
                    style={{ color: "var(--color-text)" }}
                >
                    Naples, FL — <span className="a1-accent">Where We've Worked Since 1999</span>
                </h3>
                <p
                    className="mb-4 max-w-3xl leading-relaxed text-[15.5px]"
                    style={{ color: "var(--color-text-muted)" }}
                >
                    {location.hero}
                </p>
                {neighborhoods.length ? (
                    <div className="flex flex-wrap gap-2 mb-5">
                        {neighborhoods.slice(0, 6).map((n) => (
                            <span key={n} className="a1-chip">
                                <MapPin size={12} /> {n}
                            </span>
                        ))}
                    </div>
                ) : null}
                <span className="a1-btn-ghost">
                    See Naples service <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
                </span>
            </div>
        </Link>
    );
}
